const config = require('lib/config')

/**
 * Load Facebook SDK if it is not loaded already.
 */
module.exports = function getFacebookSdk() {
    if (window.FB) {
        return Promise.resolve(window.FB)
    }

    return new Promise(resolve => {
        window.fbAsyncInit = () => {
            window.FB.init({
                appId: config.get('pumpkinhead.globals.facebook_app_id'),
                autoLogAppEvents: true,
                xfbml: true,
                version: 'v2.12',
            })
            resolve(window.FB)
        }

        // Facebook Sdk JS snippet
        /* eslint-disable */
        (function(d, s, id){
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {return;}
            js = d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
        /* eslint-enable */
    })
}
